/* document.addEventListener("DOMContentLoaded", () => {
  const callUsDrawer = document.querySelector(".callus-drawer");
  const mobileMenu = document.querySelector(".menu-drawer nav");

  // Only move if on mobile and both elements exist
  if (window.innerWidth < 1024 && callUsDrawer && mobileMenu) {
    // Insert Call Us drawer right after the nav menu
    mobileMenu.insertAdjacentElement("afterend", callUsDrawer);
  }
});
 */document.addEventListener("DOMContentLoaded", () => {
  const callUsDrawer = document.querySelector(".callus-drawer");
  const mobileMenuList = document.querySelector(".menu-drawer nav ul"); // menu items container

  // Only move if on mobile and both elements exist
  if (window.innerWidth < 1024 && callUsDrawer && mobileMenuList) {
    // Move the Call Us button drawer inside the menu at the bottom
    mobileMenuList.appendChild(callUsDrawer);

    // Optional: add a class to ensure it’s left-aligned
    callUsDrawer.classList.add("callus-btn-mobile");
  }
});
